var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1703_47221)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1703_47221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 152,
    height: 152
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.52588e-05H152V152H0V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1703_47221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.547 76C147.547 115.35 115.35 147.547 76 147.547C36.6498 147.547 4.45312 115.35 4.45312 76C4.45312 36.6498 36.6498 4.45314 76 4.45314C115.35 4.45314 147.547 36.6498 147.547 76Z",
    stroke: "#123051",
    strokeWidth: 6.51988,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0636 110.637C36.8027 108.898 39.6221 108.898 41.3612 110.637C43.1003 112.376 43.1003 115.196 41.3612 116.935C39.6221 118.674 36.8027 118.674 35.0636 116.935C33.3245 115.196 33.3245 112.376 35.0636 110.637Z",
    fill: "#123051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.639 35.0653C112.378 33.3262 115.197 33.3262 116.936 35.0653C118.675 36.8044 118.675 39.6238 116.936 41.3629C115.197 43.102 112.378 43.102 110.639 41.3629C108.9 39.6238 108.9 36.8044 110.639 35.0653Z",
    fill: "#123051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3612 35.0653C43.1003 36.8044 43.1003 39.6238 41.3612 41.3629C39.6224 43.102 36.8027 43.102 35.0636 41.3629C33.3245 39.6238 33.3245 36.8044 35.0636 35.0653C36.8027 33.3262 39.6224 33.3262 41.3612 35.0653Z",
    fill: "#123051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.936 110.637C118.675 112.376 118.675 115.196 116.936 116.935C115.197 118.674 112.378 118.674 110.639 116.935C108.9 115.196 108.9 112.376 110.639 110.637C112.378 108.898 115.197 108.898 116.936 110.637Z",
    fill: "#123051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 22.5625V31.4688",
    stroke: "#123051",
    strokeWidth: 6.51988,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 120.531V129.438",
    stroke: "#123051",
    strokeWidth: 6.51988,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5625 76H31.4688",
    stroke: "#123051",
    strokeWidth: 6.51988,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.531 76H129.438",
    stroke: "#123051",
    strokeWidth: 6.51988,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 49.2812V76L102.719 102.719",
    stroke: "#123051",
    strokeWidth: 6.51988,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1703_47221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 152,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.1e4a23cd60207c42ff137b84cdb335c8.svg";
export { ForwardRef as ReactComponent };